import request from "./request";

//获取广告主账号列表
export const getAdCountList = (data) => request("/bi/getAdvertiserInfo", data, "POST_JSON");
// 获取推广应用列表
export const getPromotedAppList = (data) => request("/tencent/campaign/promotedObjects", data, "POST");
// 获取推广计划列表
export const getCampaignList = (data) => request("/tencent/campaign/campaignList", data, "POST");
// 获取推广应用-渠道包
export const getChannelPackageList = (data) => request("/tencent/campaign/channelPackage", data, "POST");
// 创意元素配置-获取标签列表
export const getPromotedLabelList = (data) => request("/tencent/campaign/labelList", data, "POST");
// 创意元素配置-品牌形象/挂件图列表
export const getImageTemplatelList = (data) => request("/imageTemplate/list", data, "POST");
// 创意元素配置-删除品牌形象/挂件图
export const deltetImageTemplatel = (data) => request("/imageTemplate/delete", data, "POST");
// 创意元素配置-创意元素配置-品牌形象-导入那里使用 -获取应用列表
export const getBrandAppList = (data) => request("/tencent/campaign/brandList", data, "POST");
// 创意元素配置-创建品牌形象
export const createBrand = (data) => request("/tencent/campaign/createBrand", data, "POST_JSON");
// 创意元素配置-创建挂件图
export const addImageTemplatel = (data) => request("/imageTemplate/create", data, "POST_JSON");
// 创意标题-文案助手
export const getCreativeTextList = (data) => request("/tencent/campaign/creativeText", data, "POST");
// 定向包-自定义人群
export const getCustomAudiencesList = (data) => request("/tencent/campaign/customAudiences", data, "POST");
// 定向-地理位置/行为/兴趣/意向
export const getTargetingTags = (data) => request("/tencent/campaign/targetingTags", data, "POST");
// 其他配置-转化归因
export const getConversionsList = (data) => request("/tencent/campaign/conversions", data, "POST");
// 其他配置-落地页
export const getLandPageList = (data) => request("/tencent/campaign/landPages", data, "POST");
//获取广点通素材信息
export const getMaterialsInfo = (data) => request("/tencent/campaign/materials", data, "POST");
//提交预览
export const preview = (data) => request("/tencent/campaign/preview", data, "POST_JSON");
// 发布
export const publish = (data) => request("/tencent/campaign/publish", data, "POST");
// 预览列表接口
export const getPreviewList = (data) => request("/tencent/campaign/previewList", data, "POST");
// 修改计划或广告组状态
export const updateStatus = (data) => request("/tencent/campaign/updateStatus", data, "POST");
// 获取模板列表
export const queryTemplate = (data) => request("/adTemplate/list", data, "GET");
// 获取模板详情
export const getAdTemplateDatail = (data) => request("/adTemplate/detail", data, "GET");
// 创建模板
export const createTemplate = (data) => request("/adTemplate/save", data, "POST_JSON");
// 朋友圈昵称链接
export const getProfiles = (data) => request("/tencent/campaign/profiles", data, "POST");
//素材
export const getFolders = () => request("/fileMgt/getFolders", null, "GET");
export const getTag = () => request("/tag/getTag", null, "GET");
export const getDesigner = () => request("/tag/getDesigner", null, "GET");
export const getFiles = (data) => request("/fileMgt/getFiles", data, "GET");
